import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Text } from '@bingads-webui-react/fabric-control';

const ErrorReason = ({ reason }) => (
  <div>
    <Text variant="medium" styles={{ root: { color: '#A80000' } }}>{reason}</Text>
  </div>
);

ErrorReason.propTypes = {
  reason: PropTypes.string.isRequired,
};

export const ExclusionErrors = ({ errors }) => (
  errors.map(error => (
    <div key={error.Key} className="web-exclusions-error">
      {_.isEmpty(error.Value) ? <ErrorReason reason={error.Key} /> : error.Value.map(value => (
        <span key={value} style={{ display: 'block', color: 'black' }}>
          {value}:
          <ErrorReason reason={error.Key} />
        </span>
        ))}
    </div>
  ))
);

ExclusionErrors.propTypes = {
  errors: PropTypes.shape([]),
};

ExclusionErrors.defaultProps = {
  errors: [],
};
